

















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import showFilesModal from '../components/showFiles.vue';
import moment from 'moment-timezone';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'promo-detail-modal',
    components: {
        showFilesModal,
        Spinner,
    },
    filters: {
        date(val) {
            return val == null ? 'YYYY/MM/DD' : moment(val).format('YYYY/MM/DD');
        },
    },
    computed: {
        ...mapState('promos', ['activePromo', 'activePromoLoading']),
    },
})
export default class PromoDetailModal extends Vue {
    //
    private activePromo!: any;
    private activePromoLoading!: any;
    public dataPdf: any = '';
    public pdfSrc: string = '';
    public products_promo: any = [];
    public fields_product_promo: any = ['id', 'qty', 'price'];

    public dateRange: any = {
        date: null,
    };
    singleDatePicker: any = 'range';

    onRemoveImgPromotion() {
        this.activePromo.image = '';
    }

    onOpenFilesModal() {
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    onFileChange(e: any) {
        if (e.target) {
            const files = e.target.files;
            files.forEach((file: any) => {
                let formData = new FormData();
                formData.append('image', file, file.name);
                this.activePromo.image = {
                    id: uuidv4(),
                    sort: null,
                    url: URL.createObjectURL(file),
                    origin: 'upload',
                    file: formData,
                    name: file.name,
                };
            });
        } else {
            this.activePromo.image = {
                id: e.id,
                sort: null,
                url: `https://directus.prodelec.app/assets/${e.id}`,
                origin: 'directus-update',
                file: null,
            };
        }
    }

    onSetDate() {
        this.activePromo.start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
        this.activePromo.end_date = moment(this.dateRange.endDate).format('YYYY/MM/DD');
    }

    onSavePromo() {
        console.log(this.activePromo);
        this.$store.dispatch('promos/postOne', {
            vm: this,
            data: this.activePromo,
        });
    }

    onDeletePromo() {
        this.$store.dispatch('promos/deleteOne', { id: this.activePromo.id, vm: this });
        setTimeout(() => {
            this.$store.dispatch('promos/getAll');
            this.$bvModal.hide('promo-detail-modal');
        });
    }
}
